import { useState, useRef, useEffect, useCallback, useImperativeHandle, forwardRef } from "react";
// import { useGetTitle } from "../../../hooks/useGetTitle";
import { useParams } from "react-router-dom";
//import { toast } from "react-toastify";
import { SnackbarAlert, ConfirmDialog, ConfirmDialogSingle } from "../../../components/common/HelperFunc";
import * as message from "../../../constants/messages";

import { 
    Box, 
    Breadcrumbs, 
    Button, 
    FormControl, 
    Select, 
    MenuItem, 
    Typography, 
    IconButton,
    Collapse,
    TextField,
    OutlinedInput,
    InputAdornment,
    FormControlLabel,
    Switch,
    useTheme 
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search"; // MUI의 검색 아이콘
import DescriptionIcon from "@mui/icons-material/Description"; // MUI 문서 아이콘
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import dayjs from "dayjs";

import { useGetTableData, usePutTableData, useGetTableDataInQueryString } from "../../../components/Table/hooks";

import { strategyScheduleColumns, strategyEmpSearchColumns } from "../../../constants/columns";

import { TableTemplate, NewTableTemplate } from "../../../components/Table/TableTemplate";
import { ModalTemplate } from "../../../components/Table/ModalTemplate";
import Buttons from "../../../../common/Buttons";

import styled from "styled-components";

import { COLORS } from "../../../styles/colors";
import { FONT_PROPS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 32px 16px 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

//////////////////////////////////
// 위험성 감소대책 일정관리 컴포넌트(삭제예정)
//////////////////////////////////
export function StrategySchedule() {
    const { group_code, project_code } = useParams();
    const theme = useTheme();
    ////////////////////////
    // CRUD 요청
    ////////////////////////

    // 유해위험요인등록 현황 조회 요청
    const getRegisterStatusData = useGetTableData(
        "request",
        "/getRegisterStatus", 
        group_code,
        project_code
    );

    // 데이터 조회에 필요한 조건을 상태로 관리합니다. (평가연도, 평가월, 설비명)
    const [searchStatus, setSearchStatus] = useState({});
    // 데이터 조회에 필요한 쿼리스트링을 만듭니다.
    const qeuryString = { 
        params: { // 쿼리스트링 만들때 params를 사용하는게 규칙입니다.
            year: searchStatus.year,
            month: searchStatus.month,
            machine_id: searchStatus.machine_id,
        },
    }
    // 데이터 조회 요청
    const getData = useGetTableDataInQueryString(
        "request",
        "/getStrategySchedule",
        group_code,
        project_code,
        qeuryString,
    );
    // 데이터 수정 요청
    const putData = usePutTableData(
        "request",
        "/putStrategySchedule",
        group_code,
        project_code
    );

    // 필터링 목록 조회 요청 (평가년도별, 평가년도의 최신 평가 월을 가져옵니다.)
    const getFilterListData = useGetTableData(
        "request",
        "/getStrategyScheduleFilterList",
        group_code,
        project_code,
    );

    // 최신 평가연도, 최신월, 설비 카테고리 상태를 초기화합니다.
    useEffect(() => {
        // 데이터가 로드되지 않았거나 비어 있는 경우 처리 중단
        if(!getFilterListData.data || getFilterListData.data.length === 0 ) {
            return;
        }
        if(!getRegisterStatusData.data || getRegisterStatusData.data.length === 0) {
            return;
        }
        
        // 최신 평가연도 데이터 가져오기
        let latestYearData = null;
        for(let i = getFilterListData.data.length - 1; i >= 0; i--) {
            if(getFilterListData.data[i].create_year &&
                getFilterListData.data[i].latest_month) {
                latestYearData = getFilterListData.data[i];
                break;
            }
        }
        if(!latestYearData) {
            return; // 최신 평가연도 데이터가 없으면 처리 중단
        }

        const data = 
        {
            year: latestYearData.create_year,
            month: Number(latestYearData.latest_month),
            machine_id: 'all', // 모든 설비를 조회하기 위해 'all'로 설정합니다.
        };
        
        setSearchStatus(data);
    }, [getFilterListData.data, getRegisterStatusData.data]); // 경고 메시지는 무시해도 됩니다. (문제시 해결 방법 찾을 예정)

    // 데이터가 있는지 확인
    //const isData = getData.data.length > 0;
    const isData = true;

    // 데이터가 변경되었을 때 임시 데이터 저장 (테이블 데이터 표시 용도)
    const [tempGetData, setTempGetData] = useState(null);
    const handleSetTempGetData = (data) => {
        setTempGetData(data);
    };
    // 데이터 조회 시, 데이터가 변경될 때마다 임시 데이터를 갱신합니다.
    useEffect(() => {
        // if(getData.data.length === 0) {
        //     // 데이터가 없을 때
        //     return;
        // }

        const tempData = [...getData.data];
        for(let i = 0; i < tempData.length; ++i) {
            // 데이터에 인덱스 추가(행 편집 용도로 사용)
            tempData[i].index = i;
            // 담당자 설정 모달 활성화 여부를 나타내는 상태 변수
            tempData[i].hasSearchEmployee = false;
            // 개선 예정일 날짜 포맷 변경 (DB -> UI)
            tempData[i] = transFormatDateForUI(tempData[i], "expected_date");
        }
        handleSetTempGetData(tempData);
    },[getData.data]);

    // 데이터 업데이트 알람 상태 관리
    const [dataAlert, setDataAlert] = useState({
        isOpen: false,
        message: '',
        severity:'' // 'success' | 'error' | 'warning' | 'info'
    });
    const handleDataAlertOpen = (message, severity = 'success') => {
        setDataAlert({
            ...dataAlert,
            isOpen: true,
            message: message,
            severity: severity
        });
    };
    const handleDataAlertClose = () => {
        setDataAlert({
            ...dataAlert,
            isOpen: false,
            message: '',
            severity: '',
        });
    };

    // 메시지 박스의 알람 메시지
    const [messageAlram, setMessageAlram] = useState({
        isOpen: false,
        title: '',
        message: '',
    });
    const handleMessageConfirmAction = (title='', message='',) => {
        setMessageAlram({
            ...messageAlram,
            isOpen: true,
            title: title,
            message: message,
        });
    };
    const handleMessageCancel = () => {
        setMessageAlram({
            ...messageAlram,
            isOpen: false,
            title: '',
            message: '',
        });
        //console.log('❌ 취소 눌림');
    };

    // 담당자 모달 창 상태 관리
    const [searchEmployee, setSearchEmployee] = useState({
        isOpen: false,
        rowData: null,
    });
    const handleSetSearchEmployeeOpen = (rowData) => {
        setSearchEmployee({
            ...searchEmployee,
            isOpen: true,
            rowData: rowData,
        });
    };
    const handleSetSearchEmployeeClose = () => {
        setSearchEmployee({
            ...searchEmployee,
            isOpen: false,
            rowData: null,
        });
    };

    // 평가연도 목록 (중복 제거를 위한 작업)
    const yearList = Array.from(
        new Set(getFilterListData.data.map(item => item.create_year))
    );
    // 설비명 목록 (중복 제거를 위한 작업)
    const machineIdList = Array.from(
        new Map(
            getRegisterStatusData.data.map((item) => [
                item.machine_id, 
                { 
                    machine_id: item.machine_id, 
                    machine_name: item.machine_name 
                }
            ])
        ).values()
    );
    machineIdList.unshift({ machine_id: 'all', machine_name: '전체' }); // 전체 추가
    //console.log(machineIdList);

    // 테이블 참조
    const tableRef = useRef();
    const handleSelectedReset = () => { tableRef.current?.clearSelection(); };
    const handleGetSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

    // 테이블의 상단 툴바 커스터마이징 관련 내용
    const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
    const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
    const [showAdminMode, setShowAdminMode] = useState(false); // 관리자 모드 활성화 여부
    const customTableTopToolbar = (table) => (
        <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
            {/* 왼쪽 영역 */}
            <Box display={"flex"} alignItems="center" gap={4} marginLeft={'16px'}>
                {/* 평가연도 카테고리 */}
                <FormControl size="small">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                fontSize: 15,
                                color: theme.text,
                            }}
                        >
                            평가연도
                        </Typography>
                        <Select
                            value={searchStatus.year || ""}
                            displayEmpty
                            onChange={(e) => {
                                setSearchStatus({
                                    ...searchStatus,
                                    year: e.target.value,
                                });
                            }}
                            sx={{
                                width: "100px",
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                color: theme.text,
                                fontSize: 15,
                            }}
                        >
                            {/* 필터 목록 */}
                            {yearList.reverse().map((year, index) => (
                                <MenuItem
                                    key={index}
                                    value={year}
                                    sx={{
                                        fontWeight: FONT_PROPS.SEMIBOLD,
                                        color: theme.text,
                                        fontSize: 15,
                                    }}
                                >
                                    {year}년
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </FormControl>
                {/* 평가월 카테고리 */}
                <FormControl size="small">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                fontSize: 15,
                                color: theme.text,
                            }}
                        >
                            평가월
                        </Typography>
                        <Select
                            value={searchStatus.month || ""}
                            displayEmpty
                            onChange={(e) => {
                                setSearchStatus({
                                    ...searchStatus,
                                    month: e.target.value,
                                });
                            }}
                            sx={{
                                width: "80px",
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                color: theme.text,
                                fontSize: 15,
                            }}
                        >
                            {/* 필터 목록 */}
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reverse().map((month, index) => (
                                <MenuItem
                                    key={index}
                                    value={month}
                                    sx={{
                                        fontWeight: FONT_PROPS.SEMIBOLD,
                                        color: theme.text,
                                        fontSize: 15,
                                    }}
                                >
                                    {month}월
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </FormControl>
                {/* 설비명 카테고리 */}
                <FormControl size="small">
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                fontSize: 15,
                                color: theme.text,
                            }}
                        >
                            설비명
                        </Typography>
                        <Select
                            value={searchStatus.machine_id || ""}
                            displayEmpty
                            onChange={(e) => {
                                setSearchStatus({
                                    ...searchStatus,
                                    machine_id: e.target.value,
                                });
                            }}
                            sx={{
                                minWidth: "120px",
                                fontWeight: FONT_PROPS.SEMIBOLD,
                                color: theme.text,
                                fontSize: 15,
                            }}
                        >
                            {/* 필터 목록 */}
                            {machineIdList.map((data, index) => (
                                <MenuItem
                                    key={index}
                                    value={data.machine_id}
                                    sx={{
                                        fontWeight: FONT_PROPS.SEMIBOLD,
                                        color: theme.text,
                                        fontSize: 15,
                                    }}
                                >
                                    {data.machine_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </FormControl>
            </Box>
            {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
            <Box display="flex" alignItems="center" gap={2}>
                {/* 검색창 */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={() => setShowSearch((prev) => !prev)}>
                    <SearchIcon />
                    </IconButton>
                
                    <Collapse in={showSearch} orientation="horizontal">
                    <TextField
                        size="small"
                        placeholder="검색"
                        value={globalFilter}
                        onChange={(e) => {
                        setGlobalFilter(e.target.value);
                            table.setGlobalFilter(e.target.value);
                        }}
                        sx={{ minWidth: 200 }}
                        variant="outlined"
                        slots={{
                            input: OutlinedInput,
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => {
                                            setGlobalFilter('');
                                            table.setGlobalFilter('');
                                            setShowSearch(false); // 닫기
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }
                        }}
                    />
                    </Collapse>
                </Box>
                {/* 관리자 모드 */}
                <FormControl component="fieldset">
                    <FormControlLabel
                        value="top"
                        control={
                        <Switch color="primary" 
                            checked={showAdminMode}
                            onChange={(event) => setShowAdminMode(event.target.checked)}
                        />
                        }
                        label="관리자모드"
                        labelPlacement="end" // bottom,end,start,top
                        sx={{marginLeft : '4px'}}
                    />
                </FormControl>
            </Box>
        </Box>
    );

    // 테이블의 커스텀 옵션으로 된 행(row) 편집 작업
    // const handleCustomOptionsEditRow = (values, row, table) => {
    const handleCustomOptionsEditRow = ({ values, row, table }) => {
        //console.log("✅ 편집 호출 완료!", values);
        //console.log("✅ 편집 호출 완료!", row.original);

        // 담당자 검색 모달 표시
        if(values.hasSearchEmployee) {
            handleSetSearchEmployeeOpen({...values}); // 위험성 감소대책 일정관리의 행 데이터 저장
            return;
        }

        // 편집된 데이터 변경
        const findData = tempGetData.find((item) => item.index === row.original.index);
        Object.keys(values).forEach((key) => {
            if (findData[key] !== values[key]) {
                findData[key] = values[key];
            }
        });

        // TempGetData 변경
        const tempData = tempGetData.map((item) => item.index === row.original.index ? findData : item);
        handleSetTempGetData(tempData);
        
        //table.setEditingRow(null); // 에디터 모드 종료
    };
    // 테이블의 행(row) 헤더 저장 액션 (임시로 만듦)
    const customRenderRowActionHeader = showAdminMode ? (
        <Buttons.Custom
            startIcon={<CheckIcon />}
            onClick={(event) =>{
                event.stopPropagation(); // 이벤트 전파 중단
                //
                const findDatas = tempGetData.filter((item) => {
                    // 1. expected_date과 emp_id 속성의 데이터가 있는지 확인
                    // 2. improve_status 속성의 데이터가 없거나, 있더라도 일정 등록완료 전인지 확인
                    const hasDatas = item.expected_date && item.emp_id;
                    const isNotExpected = !item.improve_status || item.improve_status < 20; // 20: 일정 등록완료
                    return hasDatas && isNotExpected;
                });
                
                if(findDatas.length <= 0) {
                    handleMessageConfirmAction(
                        '안내',
                        '전체 저장할 항목이 없습니다.'
                    );
                    return;
                }

                updateEditingDatas(findDatas);
            }}
            sx={{ display: 'flex', alignItems: 'center', padding: '8px 12px' }}
        >
            전체 저장
        </Buttons.Custom>
    ) : null;
    // 테이블의 행(row) 저장 액션
    const customRenderRowActionContent = (rowData) => {
        return(
            <Buttons.Custom
                startIcon={<CheckIcon />}
                disabled={rowData.improve_status >= 20} // 20: 일정 등록완료
                onClick={(event) =>{
                    event.stopPropagation(); // 이벤트 전파 중단
                    
                    if(checkData(rowData)) {
                        handleMessageConfirmAction(
                            '안내',
                            '개선 예정일 및 담당자를 설정해주세요.'
                        );
                        return;
                    }
                    
                    updateEditingDatas(rowData);
                }}
                sx={{ padding: '8px 12px' }}
            >
                저장
            </ Buttons.Custom>
        );
    };
    // 행(row) 수정 데이터, DB 업데이트
    const updateEditingDatas = async (rowDatas) => {
        try {
            // 배열이 아닌 경우 배열로 변환
            const tempRowDatas = Array.isArray(rowDatas)? rowDatas: [rowDatas]; 
            //console.log(tempRowDatas);

            const updateDatas = [];
            tempRowDatas.forEach((item) => {
                const data = {
                    improve_id: item.improve_id,
                    expected_date: transFormatDateForDB(item.expected_date, "date"),
                    emp_id: item.emp_id,    
                    improve_status: 20, // 상태: 20(일정 등록완료)
                };
                updateDatas.push(data);
            });

            // 데이터베이스 업데이트
            const result = await putData.mutateAsync(updateDatas);
            if(result.status === 200) {
                handleDataAlertOpen(message.addSuccess);
            }
        }
        catch (error) {
            console.error("데이터 수정 중 오류 발생:", error);
        }
    }

    /////////////////////////////
    // 담당자 등록의 변수 및 함수
    /////////////////////////////

    // 담당자 등록
    const registerEmployeeAction = (rowData) => {
        //console.log(rowData);

        // 편집된 데이터 변경
        const selectedData = {...searchEmployee.rowData};
        selectedData.hasSearchEmployee = false; // 담당자 검색 모달창 변수 초기화
        selectedData.emp_id = rowData.emp_id; // 직원 ID 초기화
        selectedData.emp_name = rowData.emp_name; // 직원 이름 초기화

        // TempGetData 변경
        const tempData = tempGetData.map(
            (item) => item.index === selectedData.index ? selectedData : item
        );

        handleSetTempGetData(tempData);
        handleSetSearchEmployeeClose(); // 모달 닫기
    }

    ////////////////////////
    // Helper Functions
    ////////////////////////

    // 날짜 데이터 포맷 변경 (UI -> DB)
    const transFormatDateForDB = (value, type) => {
        if (!value) {
            return null;
        } 
        const dayjsValue = dayjs(value);
        if (!dayjsValue.isValid()) return null;
        if (type === "date") {
            return dayjsValue.format("YYYY-MM-DD");
        }
        if (type === "datetime") {
            return dayjsValue.format("YYYY-MM-DD HH:mm:ss");
        }
        return value;
    };
    
    // 날짜 데이터 포맷 변경 (DB -> UI)
    const transFormatDateForUI = (value, key) => {
        if(!value[key]) {
            return value;
        }
        const tempData = { ...value };
        const changeData = dayjs(tempData[key]);
        tempData[key] = changeData;

        return tempData;
    };

    // 데이터 빈칸 체크
    const checkData = (data) => {
        const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

        // 데이터가 없을 때
        if(tempData.length === 0) { 
            return true;
        }

        // 데이터가 있을 때
        const hasValidData = tempData.some(
            item => !item.expected_date || !item.emp_id
        );
        return hasValidData;
    };

    ////////////////////////
    // 렌더링
    ////////////////////////

    // 데이터가 있을 때 렌더링
    function renderData() {
        return (
            <TableContainer>
                {/* <TableTemplate 
                    columns={strategyScheduleColumns}
                    data={tempGetData}
                    ButtonRowActions={SaveEvaluation}
                    onEditRow={handleEditRow}
                    editDisplayMode={"row"}
                    enableCustomRowSelectType={"none"}
                    enableCustomGlobalFilter={true}
                    enableCustomTopToolbarActions={false}
                    //enableEditing={false}
                    enableCustomRowActions={true}
                    templateSX ={{
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "0.375rem", 
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
                    }}
                    enableCustomFilter={true}
                    filterOptions={{
                        yearList: yearList,
                        monthList: [1,2,3,4,5,6,7,8,9,10,11,12].reverse(),
                        machineList: machineIdList,
                        currentFilters: searchStatus
                    }}
                    onFilterChange={(newFilters) => {
                        setSearchStatus(newFilters);
                    }}
                /> */}
                <NewTableTemplate 
                    ref={tableRef}
                    columns={strategyScheduleColumns}
                    data={tempGetData || []}
                    topToolbarContent={customTableTopToolbar}
                    renderRowActionHeader={customRenderRowActionHeader}
                    renderRowActionContent={customRenderRowActionContent}
                    renderRowActionCustomOptions={handleCustomOptionsEditRow}
                    editDisplayMode={"row"}
                    enableCustomGlobalFilter={true}
                    enabledSelectionRow={false}
                    enabledSelectionAllRow={false}
                    templateSX ={{
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "0.375rem", 
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
                    }}
                />
                {/* 담당자 검색 모달 */}
                <SearchEmployee 
                    isOpen={searchEmployee.isOpen} 
                    onConfirm={registerEmployeeAction} 
                    onCancel={handleSetSearchEmployeeClose} 
                />
                {/* 기타 메시지 박스 알람 */}
                <ConfirmDialogSingle  
                    open={messageAlram.isOpen}
                    title={messageAlram.title}
                    message={messageAlram.message}
                    onCancel={handleMessageCancel}
                />
            </TableContainer>
        );
    }
    
    // 데이터가 없을 때 렌더링
    function renderNoData() {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '85vh',
                textAlign: 'center',
                padding: '32px',
            }}>
                
                <Typography variant="h1" sx={{ fontSize: '64px' }}>
                    📜
                </Typography>

                <Typography sx={{
                    fontFamily: theme.typography.fontFamily,
                    fontSize: '28px',
                    fontWeight: 500,
                    lineHeight: 1.5,
                    color: theme.palette.text.primary,
                    padding: '24px',
                }}>
                    등록된 공정이 없습니다.
                </Typography>

                <Button 
                    sx={{
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: '10px',
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                        fontSize: '20px',
                        padding: '8px 12px',
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                            transition: 'all 0.3s',
                        }
                    }}
                >
                    ➕ 추가
                </Button>
            </Box>
        );
    }

    // StrategySchedule 렌더링
    return (
        <Box sx={{ 
            bgcolor: 'var(--mui-palette-background-paper)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box
                sx={{ display: 'flex', justifyContent: 'space-between' , borderBottom: `1px solid ${theme.palette.divider}` }}
            >
                {/* 타이틀 표시 */}
                <Typography variant="h6" component="div" 
                    sx={{ 
                    //display: 'inline-block',
                    //borderRadius: 1,
                    //backgroundColor: theme.palette.primary.lighterOpacity,
                    padding: "16px 32px",
                    //fontFamily: FONT_PROPS.PRIMARY,
                    fontWeight: FONT_PROPS.SEMIBOLD,
                    lineHeight: FONT_PROPS.LINEHEIGHT,
                    fontSize: "22px",
                    color: theme.palette.text,
                    }}
                >
                    위험성 감소대책 일정관리
                </Typography>
                {/* 카테고리 표시 */}
                <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ padding: '16px 32px', display:'flex', textAlign: 'center' }}>
                    <Typography 
                        key="1" 
                        sx={{ 
                            //fontFamily: FONT_PROPS.PRIMARY,
                            fontSize: '14px',
                            fontWeight: FONT_PROPS.MEDIUM,
                            lineHeight: FONT_PROPS.LINEHEIGHT,
                            color: FONT_PROPS.GRAY,
                        }}>
                            대책관리
                    </Typography>
                    <Typography 
                        key="2" 
                        sx={{ 
                            //fontFamily: FONT_PROPS.PRIMARY,
                            fontSize: '14px',
                            fontWeight: FONT_PROPS.MEDIUM,
                            lineHeight: FONT_PROPS.LINEHEIGHT,
                            color: FONT_PROPS.GRAY,
                        }}>
                            위험성 감소대책 일정관리
                    </Typography>
                </Breadcrumbs>
            </Box>

            {/* 테이블 표시 */}
            {isData ? renderData() : renderNoData()}
        </Box>
    );
}

// 담당자 검색 모달
const SearchEmployee = ({ isOpen, onConfirm, onCancel }) =>{
    const { group_code, project_code } = useParams();
    const theme = useTheme();
    ////////////////////////
    // CRUD 요청
    ////////////////////////

    // 직원 조회 요청
    const getEmployeeData = useGetTableData(
        "request",
        "/getEmployee",
        group_code,
        project_code,
    );

    // 메시지 박스의 알람 메시지
    const [messageAlram, setMessageAlram] = useState({
        isOpen: false,
        title: '',
        message: '',
    });
    const handleMessageConfirmAction = (title='', message='',) => {
        setMessageAlram({
            ...messageAlram,
            isOpen: true,
            title: title,
            message: message,
        });
    };
    const handleMessageCancel = () => {
        setMessageAlram({
            ...messageAlram,
            isOpen: false,
            title: '',
            message: '',
        });
        //console.log('❌ 취소 눌림');
    };

    // 테이블 참조
    const tableRef = useRef();
    const handleEmployeeSelectedReset = () => { tableRef.current?.clearSelection(); };
    const handleGetEmployeeSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

    // 테이블의 상단 툴바 커스터마이징 관련 내용
    const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
    const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
    const customTableTopToolbar = (table) => (
        <Box display="flex" justifyContent="space-between" alignItems="center" p={2} bgcolor={theme.palette.background.paper} borderBottom={`1px solid ${theme.palette.divider}`}>
            {/* 왼쪽 영역 */}
            <Box display={"flex"} alignItems="center" gap={4} marginLeft={'16px'}>
                {/* 검색창 */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={() => setShowSearch((prev) => !prev)}>
                        <SearchIcon />
                    </IconButton>
                
                    <Collapse in={showSearch} orientation="horizontal">
                        <TextField
                            size="small"
                            placeholder="검색"
                            value={globalFilter}
                            onChange={(e) => {
                            setGlobalFilter(e.target.value);
                                table.setGlobalFilter(e.target.value);
                            }}
                            sx={{ minWidth: 200 }}
                            variant="outlined"
                            slots={{
                                input: OutlinedInput,
                            }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => {
                                                setGlobalFilter('');
                                                table.setGlobalFilter('');
                                                setShowSearch(false); // 닫기
                                            }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }
                            }}
                        />
                    </Collapse>
                </Box>
            </Box>
            {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
            <Box display="flex" alignItems="center" gap={2}>
                {/* TODO: */}
            </Box>
        </Box>
    );

    return (
        <ModalTemplate 
            isOpen={isOpen}
            handleConfirm={()=> {
                if(handleGetEmployeeSelectedRows().length <= 0) {
                    handleMessageConfirmAction(
                        '안내',
                        '담당자를 한 명 선택해야 등록할 수 있습니다.'
                    );
                    return;
                }
                if(handleGetEmployeeSelectedRows().length > 1) {
                    handleMessageConfirmAction(
                        '안내',
                        '담당자는 한 명만 지정할 수 있습니다.'
                    );
                    handleEmployeeSelectedReset();
                    return;
                }
                onConfirm(handleGetEmployeeSelectedRows()[0].original);
                //handleEmployeeSelectedReset();
            }}
            handleCancel={onCancel}
            confirmText="등록"
            cancelText="취소"
            title="담당자 등록"
            titleSX={{ borderBottom: 'none' }}
            contentSX={{ padding: "0px 0px 0px 0px", }}
        >
            <Box sx={{ width: '40vw' , height: '60vh', border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)'}}>
                <NewTableTemplate 
                    ref={tableRef}
                    columns={strategyEmpSearchColumns}
                    data={getEmployeeData.data || []}
                    topToolbarContent={customTableTopToolbar}
                    //renderRowActionHeader={customRenderRowActionHeader}
                    //renderRowActionContent={customRenderRowActionContent}
                    //renderRowActionCustomOptions={handleCustomOptionsEditRow}
                    //editDisplayMode={"row"}
                    enableCustomGlobalFilter={true}
                    // templateSX ={{
                    //     border: `1px solid ${theme.palette.divider}`,
                    //     borderRadius: "0.375rem", 
                    //     boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
                    // }}
                />
            </Box>
            {/* 기타 메시지 박스 알람 */}
            <ConfirmDialogSingle  
                open={messageAlram.isOpen}
                title={messageAlram.title}
                message={messageAlram.message}
                onCancel={handleMessageCancel}
            />
        </ModalTemplate >
    );
};